import * as React from 'react';
import Modal from '@medflex/components/stories/Modal';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import useMessages from '../hooks/useMessages';
import useModal from '../hooks/useModal';
import { MODALS } from '../hooks/useIsModal';

const DeleteMessageModalModule = () => {
  const { close } = useModal();
  const { t } = useTranslation('global');
  const { messageId } = useLocationSearchParams();
  const { delete: deleteMessage } = useMessages();

  const closeModal = () => close({ modal: MODALS.deleteMessage, messageId });

  const handleDelete = async e => {
    e.preventDefault();
    if (messageId) {
      try {
        await deleteMessage({ id: messageId });
        closeModal();
      } catch {
        // noop
      }
    }
  };

  return (
    <Modal
      showCloseButton
      onClickCloseButton={() => {
        closeModal();
      }}
      className="py-12 px-4 lg:px-16"
    >
      <div data-component="DeleteMessageModule" className="flex flex-col lg:px-8 mt-12 lg:mt-0">
        <h2 className="text-xl font-semibold mt-4 mb-6 leading-none">
          {t('delete_message_modal.delete')}
        </h2>
        <p>{t('delete_message_modal.text')}</p>
      </div>
      <p className="flex justify-end lg:justify-center w-full mt-16 lg:mt-8 mb-4">
        <Button className="w-128" type="button" onClick={handleDelete}>
          {t('delete_message_modal.delete')}
        </Button>
      </p>
    </Modal>
  );
};

const DeleteMessageModule = () => {
  const { modal } = useLocationSearchParams();
  if (modal && modal === 'deleteMessage') {
    return <DeleteMessageModalModule />;
  }

  return null;
};

export default DeleteMessageModule;
